import { EmailOperations } from '../email';
import { ProfileOperations } from '../profileTemp';
import { isLoginMethodProfileTemp, isLoginMethodUsername } from './utils';

const logout = (reason) => (dispatch, getState) => {
    const { loginMethod } = getState().Authentication;

    if (isLoginMethodUsername(loginMethod)) {
        dispatch(EmailOperations.logout(reason));
    }

    if (isLoginMethodProfileTemp(loginMethod)) {
        return dispatch(ProfileOperations.logout(reason));
    }

    return Promise.resolve({ isError: true, error: new Error('Login method not set') });
};

const refreshAuthentication = (forceRefresh) => (dispatch, getState) => {
    const { loginMethod } = getState().Authentication;

    if (isLoginMethodUsername(loginMethod)) {
        return dispatch(EmailOperations.refreshAuth(forceRefresh));
    }

    if (isLoginMethodProfileTemp(loginMethod)) {
        return dispatch(ProfileOperations.refreshAuth(forceRefresh));
    }

    return Promise.resolve({ isError: true, error: new Error('Login method not set') });
};

/**
 * @returns {String} the authorization header, NOT the token
 */
const getAuthorization = () => (dispatch, getState) => {
    const { loginMethod } = getState().Authentication;

    if (isLoginMethodUsername(loginMethod)) {
        return dispatch(EmailOperations.getAuthorization());
    }

    return Promise.resolve({ isError: true, error: new Error('Login method not set') });
};

export { refreshAuthentication, getAuthorization, logout };
